class MtnMobileMenu extends HTMLElement {
  constructor() {
    super();
    this.menuOpener = document.querySelector('#menuOpener');
    this.menu = this.querySelector('ul');
    this.menuItems = [...this.menu.querySelectorAll('li')];
    this.menuItems = [...this.querySelectorAll('.has-submenu')];

    this.menuItems.forEach((item) => {
      const toggleBtn = item.querySelector('button');

      if (toggleBtn) {
        toggleBtn.addEventListener('click', () => {
          if (item.classList.contains('active')) {
            item.classList.remove('active');
            return;
          }

          item.classList.add('active');
        });
      }
    });

    if (this.menuOpener) {
      this.menuOpener.addEventListener('click', this.toggleMenuOpen.bind(this));
    }
  }

  toggleMenuOpen() {
    if (this.classList.contains('opened')) {
      this.classList.remove('opened');
      return;
    }

    this.classList.add('opened');
  }
}

customElements.define('mtn-mobile-menu', MtnMobileMenu);
